module.exports = __webpack_public_path__ + "static/media/delete-drawing.1c4cf135.gif";